module.exports = __webpack_public_path__ + "static/media/12UNCTAD2.b5aab21b.jpg";